/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notify_Server_OffInputs */

const en_notify_server_off = /** @type {(inputs: Notify_Server_OffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notifications aren’t set up on the server yet.`)
};

const de_notify_server_off = /** @type {(inputs: Notify_Server_OffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mitteilungen sind auf dem Server noch nicht eingerichtet.`)
};

/**
* | output |
* | --- |
* | "Notifications aren’t set up on the server yet." |
*
* @param {Notify_Server_OffInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const notify_server_off = /** @type {((inputs?: Notify_Server_OffInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notify_Server_OffInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_notify_server_off(inputs)
	return en_notify_server_off(inputs)
});